import React from 'react';
import { AuthSwitch } from "../data/auth"
import { Dashboard, Landing } from '../components';

const Home = () => (
  <AuthSwitch>
    <Landing/>
    <Dashboard/>
  </AuthSwitch>
)

export default Home;


// WEBPACK FOOTER //
// ./src/pages/Home.js